module.exports = "images/categories.54f56d68.png";